// app/javascript/controllers/confirm_controller.js
import { Controller } from "@hotwired/stimulus"
import Swal from "sweetalert2"

export default class extends Controller {
    static values = {
        title: String,
        text: String,
        method: { type: String, default: "delete" }
    }

    async delete(event) {
        event.preventDefault()

        const title = this.titleValue || this.element.dataset.confirmTitle || "Are you sure?"
        const text  = this.textValue  || this.element.dataset.confirmText  || ""
        const method = (this.methodValue || this.element.dataset.confirmMethod || "delete").toUpperCase()

        const res = await Swal.fire({
            title,
            html: text,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete",
            cancelButtonText: "Cancel",
            buttonsStyling: false,
            customClass: {
                popup: "swal2-ea-popup",
                title: "swal2-ea-title",
                htmlContainer: "swal2-ea-text",
                confirmButton: "btn blue-button me-2",
                cancelButton: "btn btn-outline"
            }
        })
        if (!res.isConfirmed) return

        // Send the DELETE via fetch so we can handle turbo-stream response (row removal)
        const url = this.element.getAttribute("href")
        const token = document.querySelector('meta[name="csrf-token"]')?.content
        const resp = await fetch(url, {
            method,
            headers: {
                "Accept": "text/vnd.turbo-stream.html, text/html, application/xhtml+xml",
                "X-CSRF-Token": token
            }
        })

        if (resp.ok) {
            Swal.fire({
                title: "Deleted",
                icon: "success",
                timer: 1200,
                showConfirmButton: false,
                customClass: { popup: "swal2-ea-popup", title: "swal2-ea-title" }
            })
            // Turbo will apply the stream (see controller destroy action below)
        } else {
            Swal.fire({
                title: "Something went wrong",
                icon: "error",
                customClass: { popup: "swal2-ea-popup", title: "swal2-ea-title" }
            })
        }
    }
}